export enum QUERY_KEYS {
  VIDEO = 'VIDEO',
  VIDEOS = 'VIDEOS',
}

export default QUERY_KEYS
